import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import Routes from "routes";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import { themeStore } from "stores/themeStore.store";
import {
  startInactivityWatcher,
  stopInactivityWatcher,
} from "utils/inactivityWatcher";

export const Views = () => {
  const { locale, direction } = themeStore();
  const currentAppLocale = resources[locale];
  useBodyClass(`dir-${direction}`);
  useEffect(() => {
    if (window === undefined) {
      return;
    }
    const root = window.document.documentElement;
    root.setAttribute("dir", direction);
  }, [direction]);
  useEffect(() => {
    startInactivityWatcher();
    return () => stopInactivityWatcher();
  }, []);

  return (
    <ConfigProvider direction={direction} locale={currentAppLocale.antd}>
      <Routes />
    </ConfigProvider>
  );
};

export default Views;
